import React, {useState, useEffect, useContext} from 'react';
import Layout from './components/Layout';
import AdminLayout from './components/admin/AdminLayout';
import Home from './components/Home';
import Login from './components/Login';
import MediaMagic from './components/MediaMagic';
import Admin from './components/admin/Admin';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { createBrowserRouter, RouterProvider, Navigate, useNavigate, redirect } from 'react-router-dom';
import {getUserClaims,getCookie} from './services/cookies';
import { UserContext } from './components/UserContext';
import { PageContextProvider } from "./components/PageContext"
import { SubmissionContextProvider } from './components/SubmissionFormContext';
import ViewNotes from './components/ViewNotes';
import UserManager from './components/admin/AdminUsers';
import AdminPubs from './components/admin/AdminPubs';
import AdminGroupPubs from './components/admin/AdminGroupPubs';
import Validate from './components/Validate';
import ViewProof from './components/ViewProof';
import AdminStatus from './components/admin/AdminStatus';
import AdminSubStatus from './components/admin/AdminSubStatus';
import AdminSizes from './components/admin/AdminSizes';
import AdminDeadline from './components/admin/AdminDeadlines';
import AdminSites from './components/admin/AdminSites';
import LogRocket from 'logrocket';
import { DomErrorBoundry } from './components/DomErrorBoundry'
import MakeCpyProof from './components/MakeCpyProof';
import AdminModSizes from './components/admin/AdminModSizes';
import AdminModPackages from './components/admin/AdminModPackages';
import AdminHolidayDeadline from './components/admin/AdminHolidayDeadlines';
import AdminRouter from './components/admin/AdminRouter';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

interface PingAuthResponse {
    ok: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = (props) => {
    //Make sure the user is authorized before proceeding
    const [authorized, setAuthorized] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const userContext = useContext(UserContext);
    const navigate=useNavigate();

    useEffect(() => {
        async function pingAuth() {
            const url = "/api/PingAuth";
            const response: PingAuthResponse = await fetch(url, { method: "GET" });
            if (!response.ok) {
                window.location.href = "/login";
            }
            getUserClaims().then((userClaims) => {
                //console.log(userClaims);
                if (userClaims && typeof userClaims !== 'boolean') {     
                    var isSuper:boolean=false;
                    var isTrust:boolean=false;
                    var isTraffic:boolean=false;

                    // Use type assertion to access superUser property
                    if ((userClaims as any).superUser === "true") {
                        isSuper = true;
                    }
                    if ((userClaims as any).trusted==="true"||(userClaims as any).trusted==="1"){
                        isTrust=true;
                    }
                    if ((userClaims as any).trafficUser==="true"){
                        isTraffic=true;
                    }
                    userContext?.updateUser({
                        loggedIn: true,
                        username: userClaims.sub || '',
                        type: (userClaims as any).Security || 0,
                        email: (userClaims as any).email || '',
                        phone: (userClaims as any).phone||'',
                        fax:(userClaims as any).fax||"",
                        customer:(userClaims as any).Customer||"",
                        siteCode: (userClaims as any).site || '',
                        fullName:(userClaims as any).fullname||'',
                        trusted:isTrust,
                        superUser:isSuper,
                        trafficUser:isTraffic,
                        apiKey:(userClaims as any).apiKey||""
                    });
                }
                setAuthorized(true);
                setLoading(false);
            });
        }
        pingAuth();
        //check for cookie expiration
        const cookieExp= setInterval(()=>{
            console.log("Cookie Check");
            const cookie = getCookie("access_token");
            if (!cookie) {
                //redirect to login if the cookie doesn't exits
                window.location.replace("/login");
            }
        }, 2000);
        if (userContext?.user.type==40||userContext?.user.type==41){
            //this is a media magic user
            console.log("Media Magic User");
            navigate("/MediaMagic");
        }
                // Clean up the interval when the component unmounts
        return () => clearInterval(cookieExp);

    }, []);

    if (loading) {
        return (
            <>
                <p>Loading...</p>
            </>
        );
    } else {
        if (authorized && !loading) {
            return (
                <>
                    {props.children}
                </>
            );
        }
        else{
            navigate("/login");
        }
    }
    return null;
};

const router = createBrowserRouter([
    {
        path:"/",
        element:<Layout />,
        children:[            
            {
                path:"/",
                element: <ProtectedRoute><Home /></ProtectedRoute>
            },
            {
                path:"/Home/Dashboard",
                element: <Login />,
                loader: async () => {
                    return redirect("/");
                }
            },
            {
                path:"/MediaMagic",
                element: <ProtectedRoute><MediaMagic/></ProtectedRoute>
            },
            {
                path:"/Login",
                element: <Login />
            },
            {
                path:"/Home/ViewNotes",
                element: <ViewNotes/>
            },
            {
                path:"/Home/Validate",
                element: <Validate/>
            },
            {
                path:"/ViewProof",
                element: <ViewProof/>
            },
            {
                path:"/Cpy/MakeProof",
                element:<MakeCpyProof></MakeCpyProof>
            },
            {
                path:"*",
                element: <ProtectedRoute><Home /></ProtectedRoute>
            }
        ],
    },
    {
        path:"/Admin",
        element:<ProtectedRoute><AdminLayout/></ProtectedRoute>,
        children:[
            {
                path:"/Admin/Users",
                element: <ProtectedRoute><UserManager/></ProtectedRoute>
            },
            {
                path:"/Admin/Pubs",
                element: <ProtectedRoute><AdminPubs/></ProtectedRoute>
            },
            {
                path:"/Admin/GroupPubs",
                element: <ProtectedRoute><AdminGroupPubs/></ProtectedRoute>
            },
            {
                path:"/Admin/Statuses",
                element: <ProtectedRoute><AdminStatus/></ProtectedRoute>
            },
            {
                path:"/Admin/SubStatuses",
                element: <ProtectedRoute><AdminSubStatus/></ProtectedRoute>
            },
            {
                path:"/Admin/Sizes",
                element: <ProtectedRoute><AdminSizes/></ProtectedRoute>
            },
            {
                path:"/Admin/ModSizes",
                element: <ProtectedRoute><AdminModSizes/></ProtectedRoute>
            },
            {
            path:"/Admin/Packages",
                element: <ProtectedRoute><AdminModPackages/></ProtectedRoute>
            },
            {
                path:"/Admin/Sites",
                element: <ProtectedRoute><AdminSites/></ProtectedRoute>
            },
            {
                path:"/Admin/Deadlines",
                element: <ProtectedRoute><AdminDeadline/></ProtectedRoute>
            },
            {
                path:"/Admin/Holidays",
                element: <ProtectedRoute><AdminHolidayDeadline/></ProtectedRoute>
            },
            {
                path:"/Admin/Router",
                element: <ProtectedRoute><AdminRouter/></ProtectedRoute>
            }

        ]
    }
]);

const App: React.FC = () => {
    //const[isDarkMode, setIsDarkMode]=useState(true);
    
    const {switcher, themes} = useThemeSwitcher();
    const toggleTheme=()=>{
        const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        console.log("DarkMode:" + prefersDarkMode);
        switcher({theme:prefersDarkMode?themes.dark:themes.light});
    }

    useEffect(()=>{
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        mediaQuery.addEventListener('change',toggleTheme);
        toggleTheme();  
    },[])
    return (
        <DomErrorBoundry>
            <PageContextProvider>
            <RouterProvider router={router}>
            
            </RouterProvider>
            </PageContextProvider>
        </DomErrorBoundry>
    );
};

export default App;